import { all, fork } from 'redux-saga/effects';
import organizationSaga from './organizationSaga';
import stationSaga from './stationSaga';
import userSaga from './userSaga';
import homepageSaga from './homepageSaga';
import collateralSaga from './collateralSaga';
import certificateSaga from './certificateSaga';
import productionDataSaga from './productionDataSaga';
import bilateralAgreementsSaga from './bilateralAgreementsSaga';
import redemptionSaga from './redemptionSaga';
import sessionSaga from './sessionSaga';
import contractSaga from './contractSaga';
import offerSaga from './offerSaga';
import reconciliationSaga from './reconciliationSaga';
import objectionsSaga from './objectionsSaga';
import gddkSaga from './gddkSaga';
import operationHistorySaga from './operationHistorySaga';
import notificationSaga from './notificationSaga';
import utilitiesSaga from './utilitiesSaga';
import geoSaga from './geoSaga';
import inSessionCollateralSaga from "./intraSeanceCollateralSaga"


export default function* sagas() {
  yield all([
    fork(organizationSaga),
    fork(stationSaga),
    fork(userSaga),
    fork(homepageSaga),
    fork(collateralSaga),
    fork(certificateSaga),
    fork(productionDataSaga),
    fork(bilateralAgreementsSaga),
    fork(redemptionSaga),
    fork(sessionSaga),
    fork(contractSaga),
    fork(offerSaga),
    fork(reconciliationSaga),
    fork(objectionsSaga),
    fork(gddkSaga),
    fork(operationHistorySaga),
    fork(notificationSaga),
    fork(utilitiesSaga),
    fork(geoSaga),
    fork(inSessionCollateralSaga)
  ]);
}
